@if (stageMode()) {
<div class="key-info">
    <div class="info-item">
        <div>Enheter</div>
        <div class="ellipsis">
            <div class="item-max-width">{{ unitInfo() }}</div>
        </div>
    </div>

    <!-- <div class="info-item">
        <div>Salgsstart</div>
        @if(saleStart()){
        <div class="ellipsis">{{ saleStart() | evDate }}</div>
        }
    </div> -->

    <div class="info-item">
        <div>Eieform</div>
        <div class="ellipsis">{{ ownershipText() }}</div>
    </div>

    @if(developers()?.length > 0) {
    <div class="info-item">
        <div>Utvikler</div>
        <div class="ellipsis">
            @for(developer of developers(); track developer.developerCompanyId ; let last = $last) {
            <div title="{{ developer.developerCompanyName }}" class="item-max-width" [class.last]="last">{{
                developer.developerCompanyName }}</div>
            }
        </div>
    </div>
    }

    @if(estateAgents().length > 0) {
    <div class="info-item last">
        <div>Megler</div>
        <div class="ellipsis">
            @for(agent of estateAgents(); track agent.estateAgentId ; let last = $last) {
            <div title="{{ agent.estateAgentOfficeName }}" class="item-max-width" [class.last]="last">{{
                agent.estateAgentOfficeName }}</div>
            }
        </div>
    </div>
    }

</div>
} @else {
<div class="key-info">
    <div class="info-item">
        <div>Enheter</div>
        <div class="ellipsis">
            <div class="item-max-width">
                {{projectData()?.projectInfo?.numUnits}}</div>
        </div>
    </div>
    <div class="info-item">
        <div>Trinn</div>
        <div class="ellipsis">{{ projectData()?.projectInfo?.numStages }}</div>
    </div>

    @if(developers()?.length > 0) {
    <div class="info-item">
        <div>Utvikler</div>
        <div class="ellipsis">
            @for(developer of developers(); track developer.developerCompanyId ; let last = $last) {
            <div title="{{ developer.developerCompanyName }}" class="item-max-width" [class.last]="last">{{
                developer.developerCompanyName }}</div>
            }
        </div>
    </div>
    }

    @if(estateAgents().length > 0) {
    <div class="info-item last">
        <div>Megler</div>
        <div class="ellipsis">
            @for(agent of estateAgents(); track agent.estateAgentId ; let last = $last) {
            <div title="{{ agent.estateAgentOfficeName }}" class="item-max-width" [class.last]="last">{{
                agent.estateAgentOfficeName }}</div>
            }
        </div>
    </div>
    }

</div>
}
